import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../api';
import { IUpdateAdminProfilePayload } from './types';

export const updateAdminProfile = createAsyncThunk(
    'accountSettings/updateAdminProfile',
    async (payload: IUpdateAdminProfilePayload, { rejectWithValue }) => {
      try {
        const formData = new FormData();
        formData.append('full_name', payload.full_name);
        formData.append('username', payload.username);
        formData.append('user_bio', payload.userbio);
        if (payload.profile_image) {
          formData.append('profile_image', payload.profile_image);
        }
        const response = await api.patch('/user-management/admin-profile', formData);
        return response.data;
      } catch (error: any) {
          return rejectWithValue(error?.response?.data || { message: 'An unexpected error occurred' });
      }
    }
);

export const checkUsernameUniqueness = createAsyncThunk<boolean, string>(
  'accountSettings/checkUsernameUniqueness',
  async (username, { rejectWithValue }) => {
    try {
      const response = await api.post('/api/auth/username-unique', { username });
      return response.data.data.isUsernameValid; 
    } catch (error: any) {
        if (error.response && error.response.status === 409) { 
          return false;
        }
        return rejectWithValue(error?.response?.data || { message: 'Failed to check username uniqueness.' });
    }
  }
);
  
